import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { rosreestrLayersSettings } from "../../../widgets/map/mapFeatures/mapFunctions/rosreestrFunctions/rosreestrFunctions";
import { rosreestrObjectsCardFields } from "./rosreestrObjectsCardFields";
import { formatObject } from "../../../features/dataFormatFunctions/formatObject";

export const RosreestrObjectInfoCard = () => {
    const { categoryId, subcategoryId, objectId }: any = useParams()
    const [rosreestrObjectInfo, setRosreestrObjectInfo] = useState<any>(null)
    const [rosreestrObjectTypeName, setRosreestrObjectTypeName] = useState<any>('')
    const [fields, setFields] = useState<any>([])
    const selectedRosreestrObjectsByGroupId = useAppSelector(state => state.rosreestr.selectedRosreestrObjectsByGroupId)

    useEffect(() => {
        const layerSettingsFilter = ({ objectsCategoryId, objectsSubcategoryId }: any) => objectsCategoryId === categoryId && objectsSubcategoryId === subcategoryId
        const [layerIndex, rosreestrLayerSettings]: any = Object.entries(rosreestrLayersSettings).find(([layerIndex, layerSettings]) => layerSettingsFilter(layerSettings))
        const { groupId, singleCaption } = rosreestrLayerSettings
        const selectedRosreestrObjects = selectedRosreestrObjectsByGroupId?.[groupId]?.[categoryId]?.[subcategoryId]
        if (selectedRosreestrObjects) {
            const rosreestrObject = selectedRosreestrObjects.find((object: any) => object.objectId == objectId)
            const rosreestrObjectInfo = rosreestrObject?.options
            setRosreestrObjectInfo(formatObject(rosreestrObjectInfo))
        }
        if (singleCaption) {
            setRosreestrObjectTypeName(singleCaption)
        }
        const fields = rosreestrObjectsCardFields?.[layerIndex]
        if (fields) {
            setFields(fields)
        }
    }, [categoryId, subcategoryId, objectId, selectedRosreestrObjectsByGroupId])

    return (
        <>
            <ContentHeader title={rosreestrObjectTypeName} />
            <div className="rosreestr-object-info-card-div">
                <div className="rosreestr-object-info-div" >
                    {rosreestrObjectInfo
                        ?
                        <>
                            <Row>
                                <div className="section-name">{rosreestrObjectTypeName}</div>
                            </Row>
                            <Row xs={1} md={1} lg={5}>
                                {fields.map(({ field, caption }: any) =>
                                    <>
                                        <Col className="field">{caption}</Col>
                                        <Col className="value">{rosreestrObjectInfo?.[field] ?? '—'}</Col>
                                    </>
                                )}
                            </Row>
                        </>
                        :
                        <div className="no-rosreestr-object-info" >
                            По объекту нет информации на серверах Росреестра
                        </div>
                    }
                </div>
            </div >
        </>
    )
}